import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { UPSELL } from "@/lib/upsell";
import { Check, Sparkles, ArrowRight, Gift } from "lucide-react";

const FREE_FEATURES = [
  "Full opportunity discovery & scoring",
  "Unlimited AI opportunity analysis",
  "Unlimited idea validation",
  "AI idea generator (up to 25 at a time)",
  "AI build planner & competitor radar",
  "Trend radar & revenue calculator",
  "Personalized opportunity feed",
  "Builder workspace & project journey",
  "Community, watchlists & leaderboards",
  "Nova — your AI Builder Coach",
];

export default function Pricing() {
  const { user, login } = useAuth();
  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <div className="text-center mb-12">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full glass text-xs font-mono text-emerald-300 mb-5">
          <Gift className="w-3.5 h-3.5" />100% free — no credit card, ever
        </div>
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold text-slate-50">Everything, for free.</h1>
        <p className="text-slate-400 mt-3 max-w-xl mx-auto">NexxVibe is completely free to use. Discover, validate, and plan your next product with the full intelligence suite — no plans, no paywalls.</p>
      </div>

      <div className="glass rounded-2xl p-8 glow-cyan mb-12">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
          <div>
            <h2 className="font-display text-2xl font-bold text-slate-100">NexxVibe Free</h2>
            <p className="text-sm text-slate-500">Full access. Forever.</p>
          </div>
          <div><span className="font-mono text-5xl font-extrabold text-slate-50">$0</span></div>
        </div>
        <div className="grid sm:grid-cols-2 gap-x-8 gap-y-2.5 mb-8">
          {FREE_FEATURES.map((f) => <div key={f} className="text-sm text-slate-300 flex gap-2"><Check className="w-4 h-4 text-emerald-400 shrink-0 mt-0.5" />{f}</div>)}
        </div>
        {user ? (
          <Link to="/discover"><Button className="bg-cyan-500 hover:bg-cyan-400 text-slate-950 font-semibold" data-testid="pricing-cta">Start Discovering <ArrowRight className="w-4 h-4 ml-1.5" /></Button></Link>
        ) : (
          <Button onClick={login} className="bg-cyan-500 hover:bg-cyan-400 text-slate-950 font-semibold" data-testid="pricing-cta">Get Started Free <ArrowRight className="w-4 h-4 ml-1.5" /></Button>
        )}
      </div>

      {/* Upsell to companion product */}
      <div className="glass rounded-2xl p-8 border-indigo-500/30 relative overflow-hidden">
        <div className="aurora" />
        <div className="relative z-10 flex flex-col md:flex-row md:items-center gap-6">
          <div className="w-14 h-14 rounded-2xl bg-indigo-500/15 border border-indigo-500/30 flex items-center justify-center shrink-0">
            <Sparkles className="w-7 h-7 text-indigo-400" />
          </div>
          <div className="flex-1">
            <p className="text-xs font-mono uppercase tracking-widest text-indigo-400 mb-1">Ready to build it?</p>
            <h3 className="font-display text-2xl font-bold text-slate-50">{UPSELL.cta}</h3>
            <p className="text-slate-400 mt-1.5 max-w-xl">Found something worth building on NexxVibe? {UPSELL.tagline}</p>
          </div>
          <a href={UPSELL.url} target="_blank" rel="noreferrer" className="shrink-0" data-testid="upsell-cta">
            <Button className="bg-indigo-500 hover:bg-indigo-400 text-white font-semibold h-11 px-6">Visit {UPSELL.name} <ArrowRight className="w-4 h-4 ml-1.5" /></Button>
          </a>
        </div>
      </div>
    </div>
  );
}
